import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { AuthProvider } from 'src/contexts/AuthContext';
import { UserPreferencesProvider } from 'src/contexts/UserPreferencesContext';
import { AgentProvider } from 'src/contexts/AgentContext';

function App() {
  const content = useRoutes(router);

  return (
    <ThemeProvider>
      <AuthProvider>
        <UserPreferencesProvider>
          <AgentProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CssBaseline />
              {content}
            </LocalizationProvider>
          </AgentProvider>
        </UserPreferencesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
export default App;
